import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  cardActions: {
    display: 'flex',
    marginTop: '16px',
    flexDirection: 'row-reverse',
  },
  button: {
    minWidth: '125px',
  },
  buttonCancel: {
    minWidth: '125px',
  },
  alias: {
    marginTop: 0,
  },
  hint: {
    fontSize: 13,
    fontWeight: 'normal',
    color: '#1b3958',
  },
  viewSiteButton: {},
  label: {
    fontSize: '13px',
    color: '#455a64',
    marginBottom: 6,
    '&.MuiInputLabel': {
      '&-shrink': {
        transform: 'translate(0, -2px) scale(1)',
      },
    },
  },
}));

export const useStylesActiveBonCartDG = makeStyles((theme) => ({
  inputCustom: {
    margin: '0 4px',
    padding: 6,
    border: '1px solid #b0bec5 !important',
    borderRadius: '4px',
    '&:focus': {
      outline: 'none',
    },
  },
  gridBox: {
    display: 'flex',
    alignItems: 'center',
  },
}));
